(function () {
  'use strict';

  var LEAVING = 'is-leaving';
  var LOADING = 'is-loading';

  // Sayfa gitmezse fade'in takılı kalmaması için güvenlik süresi (ms).
  var STUCK_GUARD_MS = 1500;

  // Linke tıkladıktan sonra yönlendirmeden önceki bekleme (ms).
  // CSS'teki .is-leaving geçiş süresiyle aynı olmalı.
  var LEAVE_DELAY_MS = 200;

  var leaveTimer = null;
  var guardTimer = null;

  function clearTimers() {
    if (leaveTimer) { clearTimeout(leaveTimer); leaveTimer = null; }
    if (guardTimer) { clearTimeout(guardTimer); guardTimer = null; }
  }

  // Sayfayı her koşulda görünür hale getirir.
  // İKİ sınıfı da kaldırır: eski sürüm sadece is-loading'i kaldırıyordu,
  // bu yüzden geri gelindiğinde is-leaving üzerinde kalıp sayfayı
  // opacity:0 + pointer-events:none durumunda bırakıyordu.
  function reveal() {
    clearTimers();
    document.body.classList.remove(LEAVING);
    document.body.classList.remove(LOADING);
  }

  // Açılış fade'ini kaldırır. Tek bir zamanlayıcıya güvenmez:
  // mobilde sekme arka plandayken requestAnimationFrame durabiliyor,
  // o durumda setTimeout devreye girer.
  function revealSoon() {
    requestAnimationFrame(function () {
      requestAnimationFrame(reveal);
    });
    setTimeout(reveal, 60);
  }

  function shouldSkip(anchor, e) {
    // Sadece sol tık. Orta tık, ctrl/cmd/shift tık yeni sekmede açar,
    // araya girersek o davranışı bozarız.
    if (e.button !== 0) return true;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return true;
    if (e.defaultPrevented) return true;

    if (!anchor || !anchor.href) return true;
    if (anchor.target && anchor.target !== '_self') return true;
    if (anchor.hasAttribute('download')) return true;
    if (anchor.hasAttribute('data-no-transition')) return true;
    if (anchor.getAttribute('rel') === 'external') return true;
    if (anchor.closest('form')) return true;

    var url;
    try {
      url = new URL(anchor.href, location.origin);
    } catch (err) {
      return true;
    }

    if (url.origin !== location.origin) return true;

    // Aynı sayfadaki çapa linkleri ve sayfanın kendisine giden linkler
    if (url.href === location.href) return true;
    if (url.pathname === location.pathname && url.hash) return true;

    var skip = ['/checkout', '/cart', '/account', '/tools/', 'cdn.shopify'];
    for (var i = 0; i < skip.length; i++) {
      if (anchor.href.indexOf(skip[i]) !== -1) return true;
    }

    return false;
  }

  function onLinkClick(e) {
    var anchor = e.target.closest('a');
    if (shouldSkip(anchor, e)) return;

    e.preventDefault();
    var dest = anchor.href;

    document.body.classList.add(LEAVING);

    leaveTimer = setTimeout(function () {
      window.location.href = dest;
    }, LEAVE_DELAY_MS);

    // Yönlendirme herhangi bir sebeple gerçekleşmezse (mobilde zamanlayıcı
    // kısıtlaması, yavaş cihaz, engellenen navigasyon) sayfa sonsuza kadar
    // görünmez kalmasın.
    guardTimer = setTimeout(function () {
      document.body.classList.remove(LEAVING);
    }, STUCK_GUARD_MS);
  }

  // Geri/ileri ile bfcache'ten dönüldüğünde burası çalışır.
  // Sayfa zaten çizilmiş durumda, yeniden gizlemeye gerek yok: sadece aç.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      reveal();
    } else {
      revealSoon();
    }
  });

  // Sayfa bfcache'e alınırken anlık görüntü temiz olsun.
  window.addEventListener('pagehide', function () {
    document.body.classList.remove(LEAVING);
  });

  // Sekme arka plandayken zamanlayıcılar durmuş olabilir; öne gelince aç.
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) reveal();
  });

  window.addEventListener('load', reveal);

  document.body.classList.add(LOADING);
  revealSoon();
  document.addEventListener('click', onLinkClick);
})();